
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_qfm2k_22",
  "variant-recovery": "awsui_variant-recovery_4c84z_qfm2k_90",
  "variant-secondary": "awsui_variant-secondary_4c84z_qfm2k_123",
  "variant-primary": "awsui_variant-primary_4c84z_qfm2k_158",
  "variant-info": "awsui_variant-info_4c84z_qfm2k_191",
  "variant-value-large": "awsui_variant-value-large_4c84z_qfm2k_226",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_qfm2k_258",
  "button": "awsui_button_4c84z_qfm2k_293",
  "color-inverted": "awsui_color-inverted_4c84z_qfm2k_367",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_qfm2k_398",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_qfm2k_406",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_qfm2k_413",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_qfm2k_421",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_qfm2k_429",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_qfm2k_437",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_qfm2k_445",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_qfm2k_453",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_qfm2k_461",
  "in-inline-token": "awsui_in-inline-token_4c84z_qfm2k_469",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_qfm2k_473",
  "icon": "awsui_icon_4c84z_qfm2k_473"
};
  